import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {isFullUTFlexibilityEnabled} from 'modbio/util';
import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';
import strUtil from 'util/strUtil';

export default function EditPrimerBasesWarning(): JSX.Element | null {
  const affectedTypes: Array<string> = ['annotations'];
  if (BenchlingConfig.MOLBIO_ENABLE_MODIFIED_NUCLEOTIDES) {
    affectedTypes.push('chemical modifications');
  }
  if (isFullUTFlexibilityEnabled()) {
    affectedTypes.push('U/T mixed bases');
  }

  if (affectedTypes.length === 0) {
    return null;
  }

  const text = `Editing bases here will remove any existing ${strUtil.getReadableStringFromList(
    affectedTypes
  )}. As an alternative, open the oligo to edit directly.`;
  return (
    <div className={css(styles.bannerContainer)}>
      <InlineBanner bannerType={InlineBannerType.INFO} supportingInfo={text} />
    </div>
  );
}

const styles = StyleSheet.create({
  bannerContainer: {
    width: '85%',
    marginBottom: '4px',
    marginLeft: '12px',
  },
});
